import { Component, OnInit } from '@angular/core';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-social-media-carousel',
  templateUrl: './social-media-carousel.component.html',
  styleUrls: ['./social-media-carousel.component.scss']
})
export class SocialMediaCarouselComponent implements OnInit {

  slides = [
    { image: 'path/to/image1.jpg', caption: 'Slide 1' },
    { image: 'path/to/image2.jpg', caption: 'Slide 2' },
    { image: 'path/to/image3.jpg', caption: 'Slide 3' },
    // Add more slides as needed
  ];

  currentIndex = 0;
  translateValue = '0';


  constructor() { }

  ngOnInit(): void {
  }

  goToSlide(index: number) {
    this.currentIndex = index;
    this.translateValue = `-${index * 50}%`;
  }

}
